import { UNSELECT_INGREDIENT_IN_GROCERY_LIST } from "./actionTypes";

export default (id) => ({
  type: UNSELECT_INGREDIENT_IN_GROCERY_LIST,
  payload: {
    id,
  }
});